export class GrnReturnIdRequest{
    grnReturnId:number;

   
}